import { render } from "./MediaQuestionView.vue?vue&type=template&id=3583360f"
import script from "./MediaQuestionView.vue?vue&type=script&lang=js"
export * from "./MediaQuestionView.vue?vue&type=script&lang=js"

import "./MediaQuestionView.vue?vue&type=style&index=0&id=3583360f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__